@if (!busy) {
  <div class="wm-l-newtest-container">
    @if (data.editMode) {
      <div class="wm-l-newtest-section">
        <div class="wm-l-newtest-section-desc">
          <div class="wm-l-newtest-section-title">Test Description</div>
          <div class="wm-l-newtest-section-subtitle">The name and description of the test.</div>
        </div>
        <div class="wm-l-newtest-section-content">
          <div class="wm-newtest-label">
            Name
          </div>
          <div class="wm-newtest-value">
            <div class="wm-newtest-input-line">
              <input type="text" data-testing-id="new-crossbrowsertest-name-input" pInputText [(ngModel)]="name"/>
              <div class="wm-newtest-input-icon">
                @if (nameInvalid()) {
                  <fa-icon aria-hidden="true" [pTooltip]="name.length > 0 ? 'Name already exists' : 'Name must not be empty'" [tooltipZIndex]="10000" icon="exclamation-triangle" size="lg" class="error-icon"></fa-icon>
                }
              </div>
            </div>
          </div>
          <div class="wm-newtest-label">
            Description
          </div>
          <div class="wm-newtest-value">
            <div class="wm-newtest-input-line">
              <input type="text" data-testing-id="new-crossbrowsertest-description-input" pInputText [(ngModel)]="description"/>
              <div class="wm-newtest-input-icon">
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    <div class="wm-l-newtest-section">
      <div class="wm-l-newtest-section-desc">
        <div class="wm-l-newtest-section-title">URL List</div>
        <div class="wm-l-newtest-section-subtitle">The list of URLs that should be tested.</div>
      </div>
      <div class="wm-l-newtest-section-content">
        <div class="wm-m-newtest-urls">
          @for (url of urls; track trackByIndex(idx, url); let idx = $index) {
            <div class="url-entry">
              <div class="url-input">
                <div class="p-inputgroup">
                  <input type="text" pInputText placeholder="URL {{idx + 1}}" [(ngModel)]="urls[idx]" (ngModelChange)="updateBaUrlOptions()" data-testing-id="new-crossbrowsertest-url-input" id="new-crossbrowsertest-url-input-{{idx}}">
                  @if (urls.length > 1) {
                    <button pButton type="button" data-testing-id="new-crossbrowsertest-remove-url" (click)="removeUrlListItem(idx)" pButtonIcon="true">
                      <fa-icon icon="trash"></fa-icon>
                    </button>
                  }
                  @if (urls.length === 1) {
                    <button pButton type="button" (click)="clearUrl(idx)" pButtonIcon="true">
                      <fa-icon icon="trash"></fa-icon>
                    </button>
                  }
                </div>
                @if (!existingURLValid(idx)) {
                  <div class="url-validate-icon">
                    <fa-icon aria-hidden="true" [pTooltip]="'URL is not valid'" [tooltipZIndex]="10000" icon="exclamation-triangle" size="lg" class="error-icon"></fa-icon>
                  </div>
                }
                @if (existingURLValid(idx)) {
                  <div aria-hidden="true" class="url-validate-icon"></div>
                }
              </div>
            </div>
          }
          <div class="url-entry">
            <button pButton (click)="addUrlListItem()" [disabled]="!existingURLValid(urls.length - 1)" data-testing-id="new-crossbrowsertest-add-url" color="accent" label="Add URL" class="ui-button-secondary">
              <fa-icon icon="plus"></fa-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="wm-l-newtest-section" data-testing-id="reference-section">
      <div class="wm-l-newtest-section-desc">
        <div class="wm-l-newtest-section-title">Reference Browser</div>
        <div class="wm-l-newtest-section-subtitle">Please select your reference browser. This is the browser that renders the site(s) correctly.</div>
      </div>
      <div class="wm-l-newtest-section-content">
        <div class="reference-browsers">
          <div class="reference-browser-chooser" [ngClass]="{'full': !simplifiedRef}">
            @if (simplifiedRef) {
              <wm-browserchooser (browserChosen)="setReferenceBrowser($event)" [browsers]="availableReferenceBrowsers" [simpleMode]="true" [deployedBrowsers]="deployedBrowsers"
                                 [initWithBrowser]="chosenReferenceBrowser" [clear]="clearBrowser" [filterLocale]="true" class="wm-m-newtest-refbrowser"></wm-browserchooser>
            }
            @if (!simplifiedRef) {
              <wm-browserchooser (browserChosen)="setReferenceBrowser($event)" [browsers]="availableBrowsers" [deployedBrowsers]="deployedBrowsers"
                                 [initWithBrowser]="chosenReferenceBrowser" [clear]="clearBrowser" [filterLocale]="true" class="wm-m-newtest-refbrowser"></wm-browserchooser>
            }
          </div>
          @if (chosenReferenceBrowser && simplifiedRef) {
            <div class="reference-browser-info">
              <div>
                <strong>Version: </strong>{{ chosenReferenceBrowser.version }}
              </div>
              <div>
                <strong>Platform: </strong> {{ chosenReferenceBrowser.platform.getFullName() }}
              </div>
            </div>
          }
        </div>
        <div class="reference-browser-toggle-container">
          <div class="reference-browser-toggle" data-testing-id="new-crossbrowsertest-open-advanced-reference" (click)="toggleRef()">
            Show @if (simplifiedRef) {
            <span>advanced</span>
          }
            @if (!simplifiedRef) {
              <span>simple</span>
            } selection
          </div>
        </div>
      </div>
    </div>
    <div class="wm-l-newtest-section" data-testing-id="cross-section">
      <div class="wm-l-newtest-section-desc">
        <div class="wm-l-newtest-section-title">Cross-Browsers</div>
        <div class="wm-l-newtest-section-subtitle">Select the browsers you want to test for differences against the selected reference. You can choose a single or multiple browsers.</div>
      </div>
      <div class="wm-l-newtest-section-content">
        @for (b of chosenCrossBrowsers; track trackByIndex(i, b); let i = $index) {
          <div class="crossbrowsers">
            <div class="crossbrowser-heading">
              <div class="crossbrowser-heading-text">
                Cross-Browser {{ i + 1 }}
              </div>
              @if (chosenCrossBrowsers.length > 1) {
                <div class="crossbrowser-heading-icon">
                  @if (chosenCrossBrowsers.length >= 1) {
                    <fa-icon (click)="removeCrossBrowser(i)" data-testing-id="new-crossbrowsertest-remove-crossbrowser" icon="trash"></fa-icon>
                  }
                </div>
              }
            </div>
            <div>
              <wm-browserchooser (browserChosen)="updateCrossBrowser($event, i)" [browsers]="availableBrowsers"
                                 [initWithBrowser]="chosenCrossBrowsers[i]" [deployedBrowsers]="deployedBrowsers" class="wm-m-newtest-crossbrowser" [clear]="clearCrossBrowsers[i]" [filterLocale]="true"></wm-browserchooser>
            </div>
          </div>
        }
        <div class="crossbrowser-heading">
          <div class="crossbrowser-heading-text"></div>
          <div>
            <button pButton (click)="addNewBrowser()"  data-testing-id="new-crossbrowsertest-add-crossbrowser" color="accent" label="Add Cross Browser" class="ui-button-secondary">
              <fa-icon icon="plus"></fa-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="wm-l-newtest-advanced-toggle">
      <span (click)="toggleAdvancedSettings()"  data-testing-id="new-crossbrowsertest-open-advanced-settings">
        @if (!advancedSettingsShown) {
          <span>Show</span>
        }
        @if (advancedSettingsShown) {
          <span>Hide</span>
        }
        advanced settings
        @if (!advancedSettingsShown) {
          <fa-icon icon="caret-down"></fa-icon>
        }
        @if (advancedSettingsShown) {
          <fa-icon icon="caret-up"></fa-icon>
        }
      </span>
    </div>
    @if (advancedSettingsShown) {
      <div class="wm-l-newtest-section">
        <div class="wm-l-newtest-section-desc">
          <div class="wm-l-newtest-section-title">Advanced Settings</div>
          <div class="wm-l-newtest-section-subtitle">Configure additional aspects of your test, e.g. custom name or authentication data.</div>
        </div>
        <div class="wm-l-newtest-section-content">
          <p-accordion>
            <p-accordion-panel value="0" class="wm-newtest-expansion-panel" attr.data-testing-id="new-crossbrowsertest-open-pretest">
              <p-accordion-header>Pre-Test Steps</p-accordion-header>
              <p-accordion-content>

                <div class="wm-m-newtest-settings-row">
                  Provide a set of URLs and XPaths that are visited and clicked on before running the test. This is useful for accepting or declining e.g. cookie policy notifications.
                </div>
                @for (clickdriver of clickDriverConfig; track trackByIndex(clickdriverId, clickdriver); let clickdriverId = $index) {
                  <div class="wm-m-newtest-settings-row wm-newtest-settings-driverconfigs">
                    @if (!clickdriverValid(clickDriverConfig[clickdriverId])) {
                      <div class="wm-newtest-settings-driverconfigs-validation" [pTooltip]="'Step is incomplete.'" [tooltipZIndex]="10000">
                        <fa-icon aria-hidden="true" icon="exclamation-triangle" size="lg" class="error-icon"></fa-icon>
                      </div>
                    }
                    @if (clickdriverValid(clickDriverConfig[clickdriverId])) {
                      <div class="wm-newtest-settings-driverconfigs-validation">
                        <fa-icon aria-hidden="true" icon="check" size="lg" class="success-icon"></fa-icon>
                      </div>
                    }
                    <div class="wm-newtest-settings-driverconfigs-url">
                      <div class="p-inputgroup">
                        <input [(ngModel)]="clickDriverConfig[clickdriverId].url" pInputText placeholder="URL">
                        <button pButton type="button" (click)="removeClickDriverConfig(clickdriverId)" icon="true">
                          <fa-icon icon="trash"></fa-icon>
                        </button>
                      </div>
                    </div>
                    <div class="wm-newtest-settings-driverconfigs-xpaths">
                      @for (xpath of clickdriver.xpaths; track trackByIndex(xPathId, xpath); let xPathId = $index) {
                        <div class="wm-newtest-settings-driverconfigs-xpaths-xpath">
                          <div class="p-inputgroup">
                            <input [(ngModel)]="clickDriverConfig[clickdriverId].xpaths[xPathId]" pInputText placeholder="XPath" data-testing-id="new-crossbrowsertest-pretest-url-input">
                            <button pButton type="button" (click)="removeXpathFromClickDriverConfig(clickdriverId, xPathId)"  data-testing-id="new-crossbrowsertest-pretest-remove-url" [disabled]="clickDriverConfig[clickdriverId].xpaths.length <= 1" icon="true">
                              <fa-icon icon="trash"></fa-icon>
                            </button>
                          </div>
                        </div>
                      }
                    </div>
                    <button pButton (click)="addXpathToClickdriverURL(clickdriverId)" color="accent" label="Add XPath" class="ui-button-secondary wm-newtest-settings-driverconfigs-addxpath">
                      <fa-icon icon="plus"></fa-icon>
                    </button>
                  </div>
                }
                <div class="wm-m-newtest-settings-row">
                  <button pButton (click)="addUrlToClickdriver()" [disabled]="!clickdriversValid()" color="accent" label="Add Step" data-testing-id="new-crossbrowsertest-add-pretest-step" class="ui-button-secondary wm-newtest-settings-driverconfigs-addurl">
                    <fa-icon icon="plus"></fa-icon>
                  </button>
                </div>
              </p-accordion-content>
            </p-accordion-panel>
            <p-accordion-panel class="wm-newtest-expansion-panel" value="1">
              <p-accordion-header>Browser Automation</p-accordion-header>
              <p-accordion-content>
                <div class="wm-m-newtest-settings-row">
                  Configure automation helpers that run on the reference browser expedition before comparison begins.
                </div>
                <div class="wm-m-newtest-settings-editor">
                  <wm-automation-policy-editor [(ngModel)]="referenceAutomationPolicy"></wm-automation-policy-editor>
                </div>
              </p-accordion-content>
            </p-accordion-panel>
            <p-accordion-panel class="wm-newtest-expansion-panel" value="2" attr.data-testing-id="new-crossbrowsertest-open-basic-auth">
              <p-accordion-header>Basic Auth Data</p-accordion-header>
              <p-accordion-content>

                <div class="wm-m-newtest-settings-row">
                  Provide basic auth credentials for one or more domains used in the test
                </div>
                @if (browserWithoutBasicAuthSelected) {
                  <div class="wm-m-newtest-settings-row wm-newtest-settings-basicauth-error">
                    {{ basicAuthErrorMessage }}
                  </div>
                }
                @for (ba of basicAuthData; track ba; let i = $index) {
                  <div>
                    @if (basicAuthData.length > 1) {
                      <div class="ba-divider">
                        <fa-icon icon="trash" (click)="removeBAConfig(i)" data-testing-id="new-crossbrowsertest-remove-basic-auth" [pTooltip]="'Remove Basic Auth Config'" [tooltipZIndex]="'99999'"></fa-icon>
                        <span></span>
                      </div>
                    }
                    <div class="wm-m-newtest-settings-row">
                      <p-select #dropdown emptyMessage="All domains set" [ngModel]="null" [options]="baUrlOptions" (onChange)="selectBaUrl($event, i); dropdown.value = null;" placeholder="Select Domain"></p-select>
                      @for (d of ba.urls; track d; let j = $index) {
                        <div class="ba-domain-entry">
                          <span>{{ d }}</span>
                          <fa-icon icon="times" (click)="removeBaUrl(i, j)"></fa-icon>
                        </div>
                      }
                    </div>
                    <div class="wm-m-newtest-settings-row">
                      <div class="wm-m-newtest-settings-input full">
                        <input [(ngModel)]="ba.username" pInputText placeholder="Username"  data-testing-id="new-crossbrowsertest-basicauth-username-input">
                      </div>
                    </div>
                    <div class="wm-m-newtest-settings-row">
                      <div class="wm-m-newtest-settings-input full">
                        <p-password [(ngModel)]="ba.password" [feedback]="false" [style]="{width :'100%'}" placeholder="Password"  attr.data-testing-id="new-crossbrowsertest-basicauth-password-input"></p-password>
                      </div>
                    </div>
                  </div>
                }
                <div class="wm-m-newtest-settings-row">
                  <button pButton (click)="addBAConfig()"  data-testing-id="new-crossbrowsertest-add-basic-auth" [disabled]="getUnusedUrlDomains().length === 0" color="accent" label="Additional Basic Auth Config" class="ui-button-secondary">
                    <fa-icon icon="plus"></fa-icon>
                  </button>
                </div>
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>
        </div>
      </div>
    }
    <!-- TODO: need proper validation, instead of a long list of disabled-checks which are of course incomplete and non-programmatic -->
    <div class="wm-l-newtest-controls">
      <button (click)="createTest()" [disabled]="!settingsValid() || isCreatingTest" pButton data-testing-id="new-crossbrowsertest-launchBtn">
        {{ data.btnLabel }}
      </button>
    </div>
  </div>
} @else {
  <div class="wm-l-newtest-container-loading">
    <p-progressSpinner></p-progressSpinner>
    <div>Loading...</div>
  </div>
}
